import { render, staticRenderFns } from "./Hinweise.vue?vue&type=template&id=530d59bd&"
import script from "./Hinweise.vue?vue&type=script&lang=js&"
export * from "./Hinweise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Hinweise.vue"
export default component.exports